export function sineInOut(k) {
    if( k <= 0.0 ) {
        return 0.0;
    } else if( k >= 1.0 ) {
        return 1.0;
    } else {
        return -(Math.cos(Math.PI * k) - 1.0) / 2.0;
    }
}